import { render, staticRenderFns } from "./ColorFormNew.vue?vue&type=template&id=722f3bde&scoped=true&"
import script from "./ColorFormNew.vue?vue&type=script&lang=js&"
export * from "./ColorFormNew.vue?vue&type=script&lang=js&"
import style0 from "./ColorFormNew.vue?vue&type=style&index=0&id=722f3bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722f3bde",
  null
  
)

export default component.exports